export default __webpack_public_path__ + "static/media/rightArrow.8eb4bf4d.svg";